import type LocationCommonWellItemViewState from 'owa-location-common-well/lib/store/schema/LocationCommonWellItemViewState';
import { getPlace, PlaceModel } from 'owa-location-service';
import { AssetErrorType } from 'owa-timestream-asset-sdk';

export default async function getLocationDetails(
    selectedLocation: LocationCommonWellItemViewState,
    setErrorType: (error: AssetErrorType) => void
): Promise<PlaceModel | undefined> {
    let response = await getPlace(selectedLocation.persona.personaControlId);
    if (response) {
        if (response.status == 200) {
            const responseDetails = await response.json();
            return responseDetails;
        } else if (response.status == 404) {
            //404 includes 'custom' locations which are entered by clicking 'Use this location' from LocationCommonWell
            return undefined;
        }
    }
    setErrorType(AssetErrorType.Retryable);
    return undefined;
}
